import CreatePaymentContainer from './CreatePayment.container'

export default CreatePaymentContainer;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/CreatePayment/index.js